/* eslint-disable no-unused-vars */
class BackToTop extends HTMLElement {
    constructor() {
        super();
    }

    connectedCallback() {
        if (!this.backToTopInitialisieren) return;
        document.addEventListener("scroll", this.backToTopEinblenden.bind(this));
        this.button = this.querySelector('[interaction="nach-oben-scrollen"]');
        this.button.addEventListener("click", () => window.scrollTo({
            top: 0,
            left: 0,
            behavior: "smooth"
        }));
    }

    backToTopEinblenden() {
        this.buttonStatus = window.pageYOffset >= this.offset ? "aktiv" : "inaktiv";
    }

    set buttonStatus(neuerWert) {
        this.setAttribute("data-status", neuerWert);
    }

    get backToTopInitialisieren() {
        return document.body.offsetHeight >= this.minBodyHeight;
    }

    get minBodyHeight() {
        return parseInt(this.dataset.minBodyHeight);
    }

    get offset(){
        return parseInt(this.dataset.yOffset);
    }
}

customElements.get('back-to-top') || customElements.define('back-to-top', BackToTop);
